import Vue from "vue";
import App from "./App.vue";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";
// import vuetify from './plugins/vuetify';
import VueFirestore from "vue-firestore";
import router from "./router/router";
import Toasted from "vue-toasted";
import { store } from "./store/store.js";
import vuetify from './plugins/vuetify';

// import Router from "vue-router";

Vue.config.productionTip = false;
// Vue.use(Router);

Vue.use(Vuetify);
Vue.use(VueFirestore);
Vue.use(Toasted, { position: "bottom-center", duration: 3000 });

new Vue({
  render: h => h(App),
  router: router,
  vuetify,

  // vuetify
  store
}).$mount("#app");
